import { createSelector } from 'reselect';

export const selectEditor = () => state => state.get('editor');

export const selectEditorBlocks = () => createSelector(
  selectEditor(),
  editorState => editorState.get('data')
);

export const selectEditorInitialBlocks = () => createSelector(
  selectEditor(),
  editorState => editorState.get('initialData')
);

export const selectEditorReadOnly = () => createSelector(
  selectEditor(),
  editorState => editorState.get('readOnly')
);

export const selectAllowedBlockTypes = () => createSelector(
  selectEditor(),
  editorState => editorState.get('allowedBlockTypes')
);

export const selectEditorIsValid = () => createSelector(
  selectEditorBlocks(),
  blocks => blocks.every(block => block.get('isValid') !== false)
);

export const selectForceUpdateTextBlocks = () => createSelector(
  selectEditor(),
  editorState => editorState.get('forceUpdateTextBlocks')
);

export const selectEditorBlocksCount = () => createSelector(
  selectEditorBlocks(),
  blocks => blocks.size
);

export const selectBlockByKey = key => createSelector(
  selectEditorBlocks(),
  data => data.find(block => block.get('key') === key)
);

export const selectActiveBlockKey = () => createSelector(
  selectEditor(),
  editorState => editorState.get('activeBlock')
);

export const selectNewBlockKey = () => createSelector(
  selectEditor(),
  editorState => editorState.get('newBlock')
);

export const selectChangedMediaItems = () => createSelector(
  selectEditorBlocks(),
  selectEditorInitialBlocks(),
  (blocks, initialBlocks) => {
    const changedMediaItems = [];
    const mediaBlocks = blocks.filter(block => block.get('video'));

    if (mediaBlocks.size) {
      mediaBlocks.forEach((currentBlock) => {
        const initialBlock = initialBlocks.find(block => block.get('key') === currentBlock.get('key'));
        if (!initialBlock || currentBlock.getIn(['video', 'title']) !== initialBlock.getIn(['video', 'title'])) {
          changedMediaItems.push({
            id: currentBlock.getIn(['video', 'id']),
            attributes: { title: currentBlock.getIn(['video', 'title']) },
          });
        }
      });
    }

    return changedMediaItems;
  }
);
